import axios from "axios";
import { useState } from "react";
import { Imgs } from "../../img/Imgs/Imgs";
import { useSelector } from "react-redux";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";
const apiUrl = process.env.REACT_APP_API_URL;
const allowedPrefixes = ["91", "99", "96", "43", "33", "97", "55", "95", "41", "44", "66", "50", "93", "94", "77", "98"];

const CallBlock = () => {
  const [callModal, setCallModal] = useState(false);
  const [phone, setPhone] = useState("");
  const selectedLanguages = useSelector(selectedLanguage);

  const [error, setError] = useState("");
  // TODO: write scss this component

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");

    if (value.startsWith("0")) {
      value = value.slice(1);
    }

    if (value.length > 8) {
      value = value.slice(0, 8);
    }

    if (value.length >= 2) {
      const prefix = value.slice(0, 2);
      if (!allowedPrefixes.includes(prefix)) {
        setError("Հեռախոսահամարն անհրաժեշտ է լրացնել միայն թվանշաններով՝ առավելագույնը 8 նիշ, օրինակ՝ 99876543");
      } else {
        setError("");
      }
    } else {
      setError("");
    }

    let formatted = value;
    if (value.length > 2) {
      formatted = value.slice(0, 2) + " " + value.slice(2);
    }
    if (value.length > 4) {
      formatted = formatted.slice(0, 5) + "-" + formatted.slice(5);
    }
    if (value.length > 6) {
      formatted = formatted.slice(0, 8) + "-" + formatted.slice(8);
    }

    setPhone(formatted);
  };

  const reciveData = async (ev) => {
    ev.preventDefault();

    const {
      user_name: { value: user_name },
      phone_number: { value: phone_number },
    } = ev.target;

    const formData = {
      name: user_name,
      phone: phone_number,
    };

    if (!allowedPrefixes.includes(phone.replace(/\D/g, "").slice(0, 2))) {
      setError("Խնդրում ենք օգտագործել ճիշտ հեռախոսահամար։");
      return;
    }

    try {
      await axios.post(`${apiUrl}/order-call`, formData);
      setPhone("");
    } catch (error) {
      alert("please try later");
    }

    ev.target.reset();
  };

  return (
    <div className="call-block">
      {callModal && (
        <div className="call-block-context">
          <div className="call-block-context-item">
            <h2>{translations[selectedLanguages]?.callBack?.title}</h2>
            <button onClick={() => setCallModal(false)}>
              <img src={Imgs.closeCallModal} alt="" />
            </button>
          </div>
          <a href="tel:+37498936909">
            <span>{translations[selectedLanguages]?.callBack?.desc}</span> 098-93-69-09
          </a>
          <form onSubmit={reciveData}>
            <label htmlFor="user_name">
              {translations[selectedLanguages]?.callBack?.name}
              <input type="text" id="user_name" name="user_name" required autoComplete="name" />
            </label>
            <label htmlFor="phone_number" className={error && "child-part__user-error"}>
              {translations[selectedLanguages]?.callBack?.phone}
              {error && <p>{error}</p>}
              <div className="child-part__user-phone">
                <span>+374</span>
                <input
                  type="text"
                  id="phone_number"
                  name="phone_number"
                  autoComplete="tel-national"
                  maxLength="13"
                  value={phone}
                  onChange={handlePhoneChange}
                />
              </div>
            </label>
            <button>{translations[selectedLanguages]?.callBack?.send}</button>
          </form>
        </div>
      )}
      <button className="call-me" onClick={() => setCallModal(!callModal)}>
        <img src={Imgs.callMeIcon} alt="" />
        <div className="circle circle1">
          <div className="outer-circle"></div>
          <div className="inner-circle"></div>
        </div>
        <div className="circle circle2">
          <div className="outer-circle"></div>
          <div className="inner-circle"></div>
        </div>
        <div className="circle circle3">
          <div className="outer-circle"></div>
          <div className="inner-circle"></div>
        </div>
      </button>
    </div>
  );
};

export default CallBlock;
